// Links
export const CONTACT_EMAIL = 'hello@handlemytech.com';
export const EMAIL_US = `mailto:${CONTACT_EMAIL}?subject=I%27d%20like%20to%20talk%20to%20Handle%20My%20Tech`;
export const SIGNIN_URL = 'https://app.handlemytech.com';
export const BOOK_URL = '#/book';
// Booking calendar ("Schedule an Appointment") shown on the Book a call page.
export const BOOKING_WIDGET_URL = 'https://api.leadconnectorhq.com/widget/booking/o1n7aYNwP85eY2cLicDN';

// Pricing. Edit prices here only.
// Lowest price for a single service bought on its own.
export const STARTING_PRICE = 99;
// Founding-client offer shown on the pricing table. Set to '' to hide it.
export const SETUP_OFFER = 'Founding clients: setup fee waived until January 1, 2027.';
// Fair-use note shown under the packages.
export const FAIR_USE = 'Includes up to 1,000 texts a month, and 300 AI voice minutes on Front Desk. Heavier use is billed at cost.';

export const PACKAGES = [
  {
    id: 'lead',
    name: 'Never Miss a Lead',
    for: 'Stop losing jobs to voicemail and slow replies',
    price: 149,
    setup: 299,
    features: [
      'Missed-call text-back',
      'Speed-to-lead replies to new leads in seconds',
      'One inbox app for texts, calls and chats',
      'Local texting number and carrier registration handled'
    ]
  },
  {
    id: 'booked',
    name: 'Booked & Reviewed',
    for: 'Fill your calendar and grow your reviews',
    price: 299,
    setup: 299,
    popular: true,
    features: [
      'Everything in Never Miss a Lead',
      'Online booking with confirmations and reminders',
      'No-show follow-ups',
      'Review requests after every job',
      'Google profile kept up to date'
    ]
  },
  {
    id: 'frontdesk',
    name: 'Front Desk',
    for: 'A front desk that never sleeps',
    price: 499,
    setup: 499,
    features: [
      'Everything in Booked & Reviewed',
      'AI chat and voice receptionist, day and night',
      'Invoicing and online payments',
      'Win-back campaigns for past customers'
    ]
  }
];

// Services. `icon` is a react-icons/fi name (see ServiceIcon.jsx).
// `featured` services show on the home page.
export const SERVICES = [
  {
    id: 'missed-call-text-back',
    title: 'Missed-Call Text-Back',
    icon: 'FiPhoneMissed',
    featured: true,
    text: 'When you can\'t pick up, the caller gets a friendly text within seconds, so the job doesn\'t go to the next business on Google.'
  },
  {
    id: 'ai-receptionist',
    title: 'AI Chat & Voice Receptionist',
    icon: 'FiMessageCircle',
    featured: true,
    text: 'Answers calls and website chats day and night, handles common questions and books appointments for you.'
  },
  {
    id: 'speed-to-lead',
    title: 'Speed-to-Lead Instant Response',
    icon: 'FiZap',
    featured: true,
    text: 'New leads from your website, Google or Facebook get a reply in seconds, while they are still deciding who to call.'
  },
  {
    id: 'appointment-booking',
    title: 'Appointment Booking & No-Show Follow-Ups',
    icon: 'FiCalendar',
    featured: true,
    text: 'Online booking with automatic confirmations and reminders, plus a follow-up when someone misses their appointment.'
  },
  {
    id: 'reviews',
    title: 'Google Profile & Review Management',
    icon: 'FiStar',
    featured: true,
    text: 'Review requests go out after every job, and we help you reply to reviews and keep your Google profile up to date.'
  },
  {
    id: 'invoicing-payments',
    title: 'Invoicing & Online Payments',
    icon: 'FiCreditCard',
    featured: true,
    text: 'Send invoices and payment links by text or email, take card payments online, and get paid faster with less chasing.'
  },
  {
    id: 'automations',
    title: 'SMS & Automation Management',
    icon: 'FiRepeat',
    text: 'Follow-ups, reminders and routine messages that run on their own, set up and looked after by us.'
  },
  {
    id: 'win-back',
    title: 'Win-Back Campaigns',
    icon: 'FiRotateCcw',
    text: 'Reach past customers who haven\'t been back in a while with a timely message or offer that brings them in again.'
  },
  {
    id: 'email-marketing',
    title: 'Email Marketing Management',
    icon: 'FiMail',
    text: 'Newsletters and promotions written, sent and tracked for you, so your customer list keeps working for you.'
  },
  {
    id: 'social-media',
    title: 'Social Media Posting',
    icon: 'FiShare2',
    text: 'Posts planned and scheduled across your social accounts, so your business stays active without you lifting a finger.'
  },
  {
    id: 'call-tracking',
    title: 'Call Tracking & Routing',
    icon: 'FiPhoneCall',
    text: 'See which marketing makes your phone ring, and send every call to the right person.'
  },
  {
    id: 'websites',
    title: 'Website Design & Redesign',
    icon: 'FiMonitor',
    text: 'A fast, modern website that works on every phone and connects to your booking, chat and lead tools.'
  },
  {
    id: 'staff-email',
    title: 'Staff Email & Inbox Management',
    icon: 'FiInbox',
    text: 'Professional email for your team: setup, aliases, forwarding, security and ongoing help.'
  }
];

export const FAQ = [
  {
    q: 'How does pricing work?',
    a: `Most businesses pick one of our three packages, which cost less than buying the same services one by one. You can also add individual services, starting at $${STARTING_PRICE}/month each. If you need something different, we put together a custom quote on a free call.`
  },
  {
    q: 'Is there a setup fee or a contract?',
    a: 'Each package has a one-time setup fee that covers building, connecting and testing everything for your business. Founding clients get the setup fee waived until January 1, 2027. There are no long-term contracts, and you can cancel anytime.'
  },
  {
    q: 'Are texts and AI minutes included?',
    a: 'Yes, within fair use: up to 1,000 texts a month on every package, and 300 AI voice minutes on Front Desk. That covers most local businesses. If you go over, the extra is billed at cost, with no markup.'
  },
  {
    q: 'Do I need to be technical?',
    a: 'No. We set everything up, connect it to your phone number and website, and keep it running. You just use it.'
  },
  {
    q: 'Can I see my messages and leads myself?',
    a: 'Yes. You get your own login to one app with all your conversations, contacts, bookings and reviews, on your computer or phone.'
  },
  {
    q: 'Do I keep my phone number?',
    a: 'Yes. We work with your existing number, or set you up with a local number if you want a separate line for texting.'
  },
  {
    q: 'Who do I call when something needs changing?',
    a: 'Us. Send us a message or an email and we make the change for you. That is the point: you get one place to go for your tech.'
  }
];
